import { gql } from '@apollo/client/core';

export const FETCH_NAVIGATION_BADGES = gql`
  query FetchNavigationBadges {
    viewer(kind: PARENT) {
      ... on Parent {
        totalReceivedApplications
      }
      ... on Sitter {
        requests {
          totalCount
        }
      }
    }
    unreadMessageCount
  }
`;

export default {
  FETCH_NAVIGATION_BADGES,
};
